module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-08-1db557a26dfc35c3293bfac372e2c8d4.svg";